/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { GetV1UsersIdQueryResponse, GetV1UsersIdPathParams, GetV1UsersId404 } from "../../../types/GetV1UsersId.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getGetV1UsersIdUrlClient({ id }: { id: GetV1UsersIdPathParams["id"] }) {
  const res = { method: 'GET', url: `/v1/users/${id}` as const }
  return res
}

/**
 * @summary Get user details
 * {@link /v1/users/:id}
 */
export async function getV1UsersIdClient({ id }: { id: GetV1UsersIdPathParams["id"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetV1UsersIdQueryResponse, ResponseErrorConfig<GetV1UsersId404>, unknown>({ method : "GET", url : getGetV1UsersIdUrlClient({ id }).url.toString(), ... requestConfig })
  return res
}